import { exploreCategories } from '@/mocks/categories';

export default function ExploreCategories() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            Discover More
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            Explore Spreadsheet Categories
          </h2>
          <p className="text-sm text-foreground-600 max-w-[600px] mx-auto">
            Browse our comprehensive collection of product spreadsheets covering everything from fashion to electronics
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {exploreCategories.map((cat) => (
            <a
              key={cat.slug}
              href={`/${cat.slug}/`}
              className="group p-5 rounded-lg bg-background-50 border border-background-200/60 hover:border-accent-300 transition-all cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-200 transition-colors">
                <i className="ri-folder-line"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{cat.description}</p>
              <div className="flex items-center gap-1 mt-3 text-xs font-medium text-accent-600 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                <span>Explore</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}